import _ from 'lodash';
import { NodeType } from '../../utils/types';

export const RESOURCES = ['asset', 'dashboard'];


export const walkRoot = (item) => {
  if (item.parent === null) {
    return [item];
  }
  return _.flattenDeep([...walkRoot(item.parent), item]);
};


export const getTreeRoot = (item) => {
  return _.first(walkRoot(item));
};

export const getTreeRootId = (item) => {
  return _.last(_.first(walkRoot(item)).id.split('/'));
};


/**
 *
 * @param {*} item
 * @param baseUrl
 * @returns
 */
export const createPathUrl = (item, baseUrl = null) => {
  // console.log('createPathUrl', item);
  let path = 'tree';
  if (!_.has(item, 'parent') || item.parent === null) { // treeRoot item
    const [collection, id] = item.id.split('/');
    const i = (_.isEmpty(id)) ? collection : id; // handling both 'collection/id' and pure 'id'
    if (baseUrl) {
      return `${baseUrl}/${path}/${i}`;
    }
    return `${path}/${i}`;
  }
  let type = NodeType.Node;
  const p = walkRoot(item);
  while (!_.isEmpty(p)) {
    const i = p.shift();
    if (i.type !== type) {
      path += `/${i.type.toLowerCase()}`;
      type = i.type;
    }
    // path += `/${i._id.split('/')[1]}`;
    path += `/${i.id}`;
  }
  // console.log('path', path);
  if (baseUrl) {
    return `${baseUrl}/${path}`;
  }
  return path;

};


export const splitBaseRestUrl = (path) => {
  const [base, rest] = path.split('/tree/');
  if (_.isEmpty(rest)) { // no tree selected only base url in location
    return [base, []];
  }
  return [base, rest];


};


export const createTreePathList = (item) => {
  const path = walkRoot(item);
  return _.map(path, p => p.id);
};


/**
 * Parse a path and return base url, tree id if available
 * and all items in the path. TreeNode is the first item
 * @param {*} path
 * @returns
 */
export const parseLocation = (path) => {

  const [basePath, rest] = splitBaseRestUrl(path);
  if (_.isEmpty(rest)) { // no tree selected only base url in location
    return { basePath, treeRootId: null, resourceIds: rest };
  }
  let treeRootId;
  if (rest.indexOf('/') > 0) { // contains resources
    treeRootId = rest.slice(0, rest.indexOf('/'));
  } else { // only treeId
    treeRootId = rest;
  }
  const resourceIds = parseResource(rest);
  return { basePath, treeRootId, resourceIds };
};


/**
 *
 * @param {string} path
 * @returns {object} dictionary containing resourceIds for path
 * possible. Ids are possible to request directly from database. alternatives are
 * {treePath: []}
 * {treePath: [], dashboards: dashboardId}
 */
export const parseResource = (path) => {
  const found = _.map(RESOURCES, (resource) => {
    return path.indexOf(resource);
  });
  const foundResources = _.compact(found.map((i, idx) => (i >= 0) ? RESOURCES[idx] : null));
  // only nodes in path
  if (_.isEmpty(foundResources)) {
    const nodes = _.compact(path.split('/'));
    return { treePath: _.map(nodes, node => node) };
  }
  // we always split on the first resource type found, splitting for multiple is handled
  // where it understood
  const [nodePath, resourcePath] = path.split(`${foundResources[0]}/`);
  const nodes = _.compact(nodePath.split('/'));
  switch (foundResources.length) {
    case 1: // either asset or dashboard
      const resource = foundResources[0];
      switch (resource) {
        case 'asset':
          const assets = _.compact(resourcePath.split('/'));
          return {
            treePath: [
              ..._.map(nodes, node => node),
              ..._.map(assets, asset => asset)
            ]
          };
        case 'dashboard':
          const dashboards = _.first(_.compact(resourcePath.split('/')));
          return {
            treePath: _.map(nodes, node => node),
            // dashboards: _.map(dashboards, dashboard => `dashboards/${dashboard}`),
            dashboards: dashboards
          };
        default:
          console.error('wrong type of resource');
      }
      break;
    case 2: // dashboard defined under asset is supported
      const [assetPath, dashboard] = resourcePath.split('/dashboard/');
      const assets = assetPath.split('/');
      return {
        treePath: [
          ..._.map(nodes, node => node),
          ..._.map(assets, asset => asset)
        ],
        dashboards: dashboard
      };
    default:
      console.error('only 1 and 2 resources are supported');
      break;
  }
  return found;
};
